import { IconDownload } from '@costar-ui/icons/csg/IconDownload';
import React__default from 'react';

//@schang @dcatzva - template literal used for classname, fix me below!!!!!!!!!!!!
/* Review classNames */
var IconAndLabel = function IconAndLabel(fileLabel, useGrayedOutText) {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(IconDownload, {
    className: 'mr-2 inline-block align-top text-[#757575]',
    size: "24px"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "text-p-16 font-normal ".concat(useGrayedOutText ? 'text-[#BFBFBF]' : 'text-action-primary')
  }, fileLabel));
};
var ArticleFileAttachmentRelationLink = function ArticleFileAttachmentRelationLink(props) {
  var fileLabel = props.fileLabel,
    uri = props.uri;
  return uri.length > 0 ? /*#__PURE__*/React__default.createElement("a", {
    href: uri,
    target: "_blank",
    rel: "noopener noreferrer"
  }, IconAndLabel(fileLabel, false)) : /*#__PURE__*/React__default.createElement("div", null, IconAndLabel(fileLabel, true));
};

export { ArticleFileAttachmentRelationLink };
//# sourceMappingURL=article-file-attachment-relation-link.esm.js.map
